// import { Autocomplete, Grid, TextField, Typography,IconButton, Backdrop, Switch } from "@mui/material";
// import axios from "axios";
// import React, { Fragment, memo, useEffect, useState } from "react";
// import { useDispatch } from "react-redux";
// import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
// import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { useStyle } from "../style";
// import dayjs from "dayjs";
// import _ from "lodash";
// import CustomTable from "../customTable";
// import moment from "moment";
// import { Helmet } from "react-helmet-async";
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import ModalTable from "../../../../../components/utils/modalTable/modalTable";
// const OtSalesReturn = () => {
//   const classes = useStyle()
//   const dispatch = useDispatch();
//   const pageOption = [10, 25, 50, 100];
//   const [page, setPage] = useState(0);
//   const [open , setOpen] = useState(false)
//   const [rowData, setRowData] = useState(null)
//   const [rowsPerPage, setRowsPerPage] = useState(100);
//   // const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
//   const [pageCount, setPageCount] = useState(0);
//   const [data, setData] = useState([]);
//   const[salesLines , setSalesLines] = useState([])
//   const [totalAmount , setTotalAmount] = useState(0) // overall amount in footer
//   const [supplier, setSupplier] = useState([]);
//   const[cust, setCust] = useState(null)
//   const [totalFlag , setTotalFlag] = useState(false) // set the total flag true
//     const outletId = localStorage.getItem('outlet_id')
//     const roleId = localStorage.getItem("role_id")
//     const [loading, setLoading] = useState(false);
//     const [switchData , setSwitchData] = useState([])

//     const [dateLimit, setDateLimit] = useState({
//     // fromDate : moment().subtract(1,"months").format(),
//     fromDate: moment().startOf('month').format(),
//     toDate : moment().format()
//   })
//   const onEdit = (e) => {
//     console.log(e.row)
//     setSalesLines(e.row.sales_lines)
//     setRowData(e.row)
//     setOpen(true)
//   }
//   // function getSupplierData() {
//   //   axios
//   //     .get("/v1/outlet/list/1")
//   //     .then((res) => {
//   //       _.filter(res.data,val=>val.id== outletId).map(val=>setCust(val))
//   //       setSupplier(res.data);
//   //     })
//   //     .catch((err) => {
//   //       dispatch(setSnackbar(true, "error", err.response.data.error));
//   //     });
//   // }
//   function getSupplierData() {
//     axios
//       .get("/v1/outlet/list/1")
//       .then((res) => {
//         _.filter(res.data, val => val.id == outletId).map(val => setCust(val));
//         setSupplier(res.data);
//       })
//       .catch((err) => {
//         dispatch(setSnackbar(true, "error", err.response.data.error));
//       });
//   }

// const columns = [
//   {
//     field : 'sno',
//     headerName : 'S.no',
//     minWidth : 70,
//     maxWidth : 100,
//     headerAlign : 'center',
//     align : 'center',
//     sortable: false
//   },
//   {
//     field: "date1",
//     headerName: "Date",
//     minWidth : 90,
//     headerAlign: "center",
//     align: "center",
//     sortable: false,
//   },
//   {
//     field: "docNo",
//     headerName: "Doc No",
//     minWidth : 170,
//     headerAlign: "center",
//     align: "center",
//     sortable: false,
//   },
//   {
//     field: "billNO",
//     headerName: "Bill No",
//     minWidth : 170,
//     headerAlign: "center",
//     align: "center",
//     sortable: false,
//   },
//   {
//     field: "party_name",
//     headerName: "Party Name",
//     minWidth : 170,
//     headerAlign: "center",
//     align: "center",
//     sortable: false,
//   },
//   {
//     field: "subtotal_amount",
//     headerName: "Subtotal Amount",
//     minWidth : 170,
//     headerAlign: "center",
//     align: "center",
//     sortable: false,
//   },
//   {
//     field: "gst_amt",
//     headerName: "Gst Amount",
//     minWidth : 120,
//     headerAlign: "center",
//     align: "center",
//     sortable: false,
//   },
//   {
//     field: "splDiscount",
//     headerName: "Discount Amount",
//     minWidth : 120,
//     headerAlign: "center",
//     align: "center",
//     sortable: false,
//   },
//   // {
//   //   field: "roff",
//   //   headerName: "Roff",
//   //   minWidth : 100,
//   //   headerAlign: "center",
//   //   align: "center",
//   //   sortable: false,
//   // },
//   {
//     field: "amount",
//     headerName: "Amount",
//     minWidth : 100,
//     headerAlign: "center",
//     align: "center",
//     sortable: false,
//     renderCell: (params) => (
//       <strong>{params.value}</strong>
//     ),
//   },
//   {
//     field: "mode",
//     headerName: "Mode Type",
//     minWidth : 100,
//     headerAlign: "center",
//     align: "center",
//     sortable: false,
//     renderCell: (params) => (
//       <strong>{params.value}</strong>
//     ),
//   },
//   {
//     field: "status", // Or change this to "refundStatus" if you prefer
//     disableExport: true,
//     headerName: "Mode Change", // Update the label to reflect the new name
//     headerAlign: "center",
//     align: "center",
//     sortable: false,
//     renderCell: (params) => (
//       <Switch
//         onChange={() => onRefundStatusChange(params.row)} // Trigger refund status change
//         checked={params.row.refundStatus} // Reflect updated refund status
//       />
//     ),
//   },
  
//   {
//     field: "view",
//     headerName: "View",
//     disableExport: true ,
//     minWidth: 130,
//     headerAlign: "center",
//     align: "center",
//     sortable: false,
//     renderCell: (params) => {
//       return (
//         <div>
//           <IconButton size="small" onClick={() => onEdit(params)}>
//           <VisibilityIcon sx={{fontSize: 18}} />
//         </IconButton>
//         </div>
//       );
//     },
//   },
// ]

// console.log(data[0],"checkkkff")
// const rows = _.map(data,(val,idx)=>({
//   id: val.id,
//   sno: idx+1,
//   date1 : moment(val.docdate).format('DD-MM-YYYY'),
//   docNo : val.docno,
//   // docNo : val.docno.replace("_", "/").replace("_", "-").replace("_", "/"),
//   billNO:val.bill_no.replace("_", "/").replace("_", "-").replace("_", "/"),
//   head : val.accid,
//   party_name:val.party_name || "-",
//   subtotal_amount : parseFloat(val.subtotal_amount).toFixed(0),
//   gst_amt:parseFloat(val.gst_amt).toFixed(0) || '-',
//   // roff:val.roff || '-',
//   tot: parseFloat(val.amount).toFixed(0),
//   amount : parseFloat(val.amount).toFixed(0),
//   sales_lines:val.outlet_sales_lines,
//   splDiscount:parseFloat(val.discount_amount).toFixed(0),
//   tot_amt: parseFloat(val.amount).toFixed(0),
//   documentNo:val.docno.replace("_", "/").replace("_", "-").replace("_", "/"),
//   documentDate:moment(val.docdate).format("DD-MM-YYYY"),
//   refundStatus: val.is_refund,
//   mode: val.is_refund === true ? "Cash" : "Next Bill"
// }))
// const props = {
//   columns : columns,
//   rows : rows,
//   page: page,
//   setPage: setPage,
//   rowsPerPage: rowsPerPage,
//   setRowsPerPage: setRowsPerPage,
//   pageCount: pageCount,
//   pageOption: pageOption,
//   totalAmount:totalAmount,
//   totalFlag:totalFlag
// }
// const tableHeadData = [
//     { id:1, label: "S No" },
//     { id:2, label: "Barcode" },
//     { id:3 , label:"MRP"},
//     { id:4 , label:"Gst Amnt"},
//     { id:5 , label:"Disc Amnt"},
//     { id:6, label:"Gst Per"},
//     { id:7 , label:"Qty"},
//     { id:8 , label:"Rate"},
//     {id:9, label: 'Total'},

//   ];
//   const tableBodyData = _.map(salesLines, (val,idx) => ({
//     id:idx,
//     sNo:idx+1,
//     name:val.barcode,
//     docNo:val.docno.replace("_", "/").replace("_", "-").replace("_", "/"),
//     docDate:moment(val.docdate).format('DD-MM-YYYY'),
//     Mrp:val.mrp,
//     gstAmnt:val.gst_amt,
//     splDiscount:val.dis_amt,
//     gstPer:val.gst_per,
//     Qty:val.qty,
//     Rate:val.rate,
//     pro_name:val.pro_name,
//     totalAmount: val.qty > 0 ? (parseFloat(val.qty) * parseFloat(val.rate) + parseFloat(val.gst_amt)).toFixed(0) : "0.00"

//     // totalAmount : parseFloat( val.qty * val.rate   ).toFixed(2)
//   }))
//   console.log(data,"tableBodyData");
  
//   function handleChange(e, name) {
//     setDateLimit(prev=>({...prev,[name] : dayjs(e).format() }))
//   }
//   const onRefundStatusChange = (row) => {
//     console.log('Current refundStatus:', row.refundStatus); // Log before change
//     const updatedRefundStatus = !row.refundStatus;
//     console.log('Updated refundStatus:', updatedRefundStatus); // Log after change
    
//     const switchData = {
//       // docno: "RSP_24_25_72",
//       docno: row.docNo,
//       is_refund: updatedRefundStatus,
//     };
  
//     axios
//       .post(`/v1/outlet_sales_return_master/update/bycash/nbill`, switchData)
//       .then((res) => {
//         console.log("Refund status updated successfully:", res);
        
//         setData((prevData) =>
//           prevData.map((item) =>
//             item.docNo === row.docNo ? { ...item, refundStatus: updatedRefundStatus } : item
//           )
//         );
//         // dispatch(setSnackbar(true, "success", "Refund status updated successfully."));
//         handlePaymentReport()
//       })
//       .catch((err) => {
//         console.error("Error updating refund status:", err);
//         dispatch(setSnackbar(true, "error", err.response?.data?.errors?.[0]?.message || "An error occurred"));
//       });
//   };
  
// function handlePaymentReport(){
//   setLoading(true);
//   const postData = {
//     from_date:moment(dateLimit.fromDate).format('YYYY-MM-DD'),
//     to_date:moment(dateLimit.toDate).format('YYYY-MM-DD'),
//     customer: cust!==null ? cust.id : outletId
//     // outlet_id: selectedOutlet ? selectedOutlet.id : outletId
//   }
//   console.log(postData)
//   axios.post('/v1/reports/outlet_sales/return', postData)
//   .then(res=>{
//     setData(res.data)
//     console.log(res.data,"resdataaa");
//     setSwitchData(res.data.data)
//     setPageCount(res.data.length)
//   })
//   .catch(err=>{
//     setData([])
//     console.log(err)
//     dispatch(setSnackbar(true, "error", "No Data Found"));
//   })
//   .finally(() => {
//     setLoading(false); // Stop loading after request
//   });
// }
// useEffect(() => {
//     setTotalFlag(true)
//     let total = 0;
  
//     data.forEach(val => {
//         total += parseFloat(val.amount);
//     });
//     setTotalAmount(total.toFixed(0));
//   }, [data]);
//   console.log(data)
//   useEffect(()=>{
//     if(dateLimit.fromDate!==null && dateLimit.toDate!==null){
//       handlePaymentReport()
//     }
//   },[rowsPerPage, page, dateLimit,cust,switchData])
//   useEffect(() => {
//     getSupplierData();
//   }, []);
//   return (
//     <Fragment>
//       <Helmet><title>Ot Sales Return Reports</title></Helmet>
//       <Typography variant="h6">Ot Sales Return Reports</Typography>
//       <Grid container spacing={2} className="p-2 pt-2">
//       <Grid item md={3}>
//           <Autocomplete 
//             size="small"
//             value={cust}
//             options={supplier}
//             onChange={(e,value)=>setCust(value)}
//             // onChange={(e, value) => {
//             //   setCust(value);
//             //   // Trigger data fetch when outlet changes
//             //   handlePaymentReport();
//             // }}
//             getOptionLabel={option=>option.fullname} 
//             disabled={roleId != 1 && roleId != 2} 
//             renderInput={(params) => <TextField {...params} label="Select Outlet"
//             InputProps={{
//               ...params.InputProps,
//               readOnly: true,
//             }}  
//             />}
//           />
//         </Grid>
//         <Grid item md={3}>
//           <LocalizationProvider dateAdapter={AdapterDayjs}>
//             <DatePicker
//               onChange={(e) => handleChange(e, "fromDate")}
//               value={dayjs(dateLimit.fromDate)}
//               format='DD-MM-YYYY'
//               slotProps={{
//                 textField: {
//                   size: "small",
//                   label:'From',
//                   style:{width : '100%'}
//                 },
//               }}
//             />
//           </LocalizationProvider>
//         </Grid>
//         <Grid item md={3}>
//           <LocalizationProvider dateAdapter={AdapterDayjs}>
//             <DatePicker
//               onChange={(e) => handleChange(e, "toDate")}
//               value={dayjs(dateLimit.toDate)}
//               format='DD-MM-YYYY'
//               slotProps={{
//                 textField: {
//                   size: "small",
//                   label:'To',
//                   style:{width : '100%'}
//                 },
//               }}
//             />
//           </LocalizationProvider>
//         </Grid>
//       </Grid>
//       <CustomTable props={props}/>
//       <Backdrop open={open} sx={{zIndex:9999,}}>
      
//         <ModalTable tableHeadData={tableHeadData} tableBodyData={tableBodyData} setOpen={setOpen} data={rowData}/>
   
      
//       </Backdrop>
//     </Fragment>
//   );
// };

// export default memo(OtSalesReturn);


import {
  Autocomplete,
  Grid,
  TextField,
  Typography,
  IconButton,
  Backdrop,
  Switch,
} from "@mui/material";
import axios from "axios";
import React, { Fragment, memo, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useStyle } from "../style";
import dayjs from "dayjs";
import _ from "lodash";
import CustomTable from "../customTable";
import moment from "moment";
import { Helmet } from "react-helmet-async";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ModalTable from "../../../../../components/utils/modalTable/modalTable";
const OtSalesReturn = () => {
  const classes = useStyle();
  const dispatch = useDispatch();
  const pageOption = [10, 25, 50, 100];
  const [page, setPage] = useState(0);
  const [open, setOpen] = useState(false);
  const [rowData, setRowData] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  // const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
  const [pageCount, setPageCount] = useState(0);
  const [data, setData] = useState([]);
  const [salesLines, setSalesLines] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0); // overall amount in footer
  const [supplier, setSupplier] = useState([]);
  const [cust, setCust] = useState(null);
  const [totalFlag, setTotalFlag] = useState(false); // set the total flag true
  const outletId = localStorage.getItem("outlet_id");
  const roleId = localStorage.getItem("role_id");
  const [loading, setLoading] = useState(false);
  const [switchData, setSwitchData] = useState([]);

  const [dateLimit, setDateLimit] = useState({
    // fromDate : moment().subtract(1,"months").format(),
    fromDate: moment().startOf("month").format(),
    toDate: moment().format(),
  });
  const onEdit = (e) => {
    console.log(e.row);
    setSalesLines(e.row.sales_lines);
    setRowData(e.row);
    setOpen(true);
  };
  // function getSupplierData() {
  //   axios
  //     .get("/v1/outlet/list/1")
  //     .then((res) => {
  //       _.filter(res.data,val=>val.id== outletId).map(val=>setCust(val))
  //       setSupplier(res.data);
  //     })
  //     .catch((err) => {
  //       dispatch(setSnackbar(true, "error", err.response.data.error));
  //     });
  // }
  function getSupplierData() {
    axios
      .get("/v1/outlet/list/1")
      .then((res) => {
        _.filter(res.data, (val) => val.id == outletId).map((val) =>
          setCust(val),
        );
        setSupplier(res.data);
      })
      .catch((err) => {
        dispatch(setSnackbar(true, "error", err.response.data.error));
      });
  }

  const columns = [
    {
      field: "sno",
      headerName: "S.no",
      minWidth: 70,
      maxWidth: 100,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "date1",
      headerName: "Date",
      minWidth: 90,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "docNo",
      headerName: "Doc No",
      minWidth: 170,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "billNO",
      headerName: "Bill No",
      minWidth: 170,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "party_name",
      headerName: "Party Name",
      minWidth: 170,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "subtotal_amount",
      headerName: "Subtotal Amount",
      minWidth: 170,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "gst_amt",
      headerName: "Gst Amount",
      minWidth: 120,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "splDiscount",
      headerName: "Discount Amount",
      minWidth: 120,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    // {
    //   field: "roff",
    //   headerName: "Roff",
    //   minWidth : 100,
    //   headerAlign: "center",
    //   align: "center",
    //   sortable: false,
    // },
    {
      field: "amount",
      headerName: "Amount",
      minWidth: 100,
      headerAlign: "center",
      align: "center",
      sortable: false,
      renderCell: (params) => <strong>{params.value}</strong>,
    },
    {
      field: "mode",
      headerName: "Mode Type",
      minWidth: 100,
      headerAlign: "center",
      align: "center",
      sortable: false,
      renderCell: (params) => <strong>{params.value}</strong>,
    },
    {
      field: "status", // Or change this to "refundStatus" if you prefer
      disableExport: true,
      headerName: "Mode Change", // Update the label to reflect the new name
      headerAlign: "center",
      align: "center",
      sortable: false,
      renderCell: (params) => (
        <Switch
          onChange={() => onRefundStatusChange(params.row)} // Trigger refund status change
          checked={params.row.refundStatus} // Reflect updated refund status
          disabled={params.row.adjustment_status === "Adjusted"}
        />
      ),
    },

    {
      field: "adjustment_status",
      headerName: "Status",
      minWidth: 170,
      headerAlign: "center",
      align: "center",
      sortable: false,
      renderCell: (params) => {
        let bgColor = "";
        let textColor = "#fff";

        if (params.value === "Refunded") {
          bgColor = "#2e7d32"; // Green
        } else if (params.value === "Pending") {
          bgColor = "#ed6c02"; // Orange
        } else if (params.value === "Adjusted") {
          bgColor = "#1976d2"; // Blue
        }

        return (
          <Typography
            sx={{
              backgroundColor: bgColor,
              color: textColor,
              px: 1.5,
              py: 0.5,
              borderRadius: "12px",
              fontSize: "12px",
              fontWeight: 600,
              textAlign: "center",
              minWidth: "90px",
            }}
          >
            {params.value}
          </Typography>
        );
      },
    },

    {
      field: "view",
      headerName: "View",
      disableExport: true,
      minWidth: 130,
      headerAlign: "center",
      align: "center",
      sortable: false,
      renderCell: (params) => {
        return (
          <div>
            <IconButton size="small" onClick={() => onEdit(params)}>
              <VisibilityIcon sx={{ fontSize: 18 }} />
            </IconButton>
          </div>
        );
      },
    },
  ];

  console.log(data[0], "checkkkff");
  const rows = _.map(data, (val, idx) => ({
    id: val.id,
    sno: idx + 1,
    date1: moment(val.docdate).format("DD-MM-YYYY"),
    docNo: val.docno,
    // docNo : val.docno.replace("_", "/").replace("_", "-").replace("_", "/"),
    billNO: val.bill_no.replace("_", "/").replace("_", "-").replace("_", "/"),
    head: val.accid,
    party_name: val.party_name || "-",
    subtotal_amount: parseFloat(val.subtotal_amount).toFixed(0),
    gst_amt: parseFloat(val.gst_amt).toFixed(0) || "-",
    // roff:val.roff || '-',
    tot: parseFloat(val.amount).toFixed(0),
    amount: parseFloat(val.amount).toFixed(0),
    sales_lines: val.outlet_sales_lines,
    splDiscount: parseFloat(val.discount_amount).toFixed(0),
    tot_amt: parseFloat(val.amount).toFixed(0),
    documentNo: val.docno.replace("_", "/").replace("_", "-").replace("_", "/"),
    documentDate: moment(val.docdate).format("DD-MM-YYYY"),
    refundStatus: val.is_refund,
    mode: val.is_refund === true ? "Cash" : "Next Bill",
    adjustment_status:
      val.is_adjusted === true
        ? "Adjusted"
        : val.is_refund === true
          ? "Refunded"
          : "Pending",
  }));
  const props = {
    columns: columns,
    rows: rows,
    page: page,
    setPage: setPage,
    rowsPerPage: rowsPerPage,
    setRowsPerPage: setRowsPerPage,
    pageCount: pageCount,
    pageOption: pageOption,
    totalAmount: totalAmount,
    totalFlag: totalFlag,
  };
  const tableHeadData = [
    { id: 1, label: "S No" },
    { id: 2, label: "Barcode" },
    { id: 3, label: "MRP" },
    { id: 4, label: "Gst Amnt" },
    { id: 5, label: "Disc Amnt" },
    { id: 6, label: "Gst Per" },
    { id: 7, label: "Qty" },
    { id: 8, label: "Rate" },
    { id: 9, label: "Total" },
  ];
  const tableBodyData = _.map(salesLines, (val, idx) => ({
    id: idx,
    sNo: idx + 1,
    name: val.barcode,
    docNo: val.docno.replace("_", "/").replace("_", "-").replace("_", "/"),
    docDate: moment(val.docdate).format("DD-MM-YYYY"),
    Mrp: val.mrp,
    gstAmnt: val.gst_amt,
    splDiscount: val.dis_amt,
    gstPer: val.gst_per,
    Qty: val.qty,
    Rate: val.rate,
    pro_name: val.pro_name,
    totalAmount:
      val.qty > 0
        ? (
            parseFloat(val.qty) * parseFloat(val.rate) +
            parseFloat(val.gst_amt)
          ).toFixed(0)
        : "0.00",

    // totalAmount : parseFloat( val.qty * val.rate   ).toFixed(2)
  }));
  console.log(data, "tableBodyData");

  function handleChange(e, name) {
    setDateLimit((prev) => ({ ...prev, [name]: dayjs(e).format() }));
  }
  const onRefundStatusChange = (row) => {
    console.log("Current refundStatus:", row.refundStatus); // Log before change
    const updatedRefundStatus = !row.refundStatus;
    console.log("Updated refundStatus:", updatedRefundStatus); // Log after change

    const switchData = {
      // docno: "RSP_24_25_72",
      docno: row.docNo,
      is_refund: updatedRefundStatus,
    };

    axios
      .post(`/v1/outlet_sales_return_master/update/bycash/nbill`, switchData)
      .then((res) => {
        console.log("Refund status updated successfully:", res);

        // setData((prevData) =>
        //   prevData.map((item) =>
        //     item.docNo === row.docNo
        //       ? { ...item, refundStatus: updatedRefundStatus }
        //       : item,
        //   ),
        // );
        setData((prevData) =>
          prevData.map((item) =>
            item.docno === row.docNo // ✅ item.docno matches raw API response
              ? { ...item, is_refund: updatedRefundStatus }
              : item,
          ),
        );
        // dispatch(setSnackbar(true, "success", "Refund status updated successfully."));
        handlePaymentReport();
      })
      .catch((err) => {
        console.error("Error updating refund status:", err);
        dispatch(
          setSnackbar(
            true,
            "error",
            err.response?.data?.errors?.[0]?.message || "An error occurred",
          ),
        );
      });
  };

  function handlePaymentReport() {
    setLoading(true);
    const postData = {
      from_date: moment(dateLimit.fromDate).format("YYYY-MM-DD"),
      to_date: moment(dateLimit.toDate).format("YYYY-MM-DD"),
      customer: cust !== null ? cust.id : outletId,
      // outlet_id: selectedOutlet ? selectedOutlet.id : outletId
    };
    console.log(postData);
    axios
      .post("/v1/reports/outlet_sales/return", postData)
      .then((res) => {
        setData(res.data);
        console.log(res.data, "resdataaa");
        setSwitchData(res.data.data);
        setPageCount(res.data.length);
      })
      .catch((err) => {
        setData([]);
        console.log(err);
        dispatch(setSnackbar(true, "error", "No Data Found"));
      })
      .finally(() => {
        setLoading(false); // Stop loading after request
      });
  }
  useEffect(() => {
    setTotalFlag(true);
    let total = 0;

    data.forEach((val) => {
      total += parseFloat(val.amount);
    });
    setTotalAmount(total.toFixed(0));
  }, [data]);
  console.log(data);
  useEffect(() => {
    if (dateLimit.fromDate !== null && dateLimit.toDate !== null) {
      handlePaymentReport();
    }
  }, [rowsPerPage, page, dateLimit, cust]);
  useEffect(() => {
    getSupplierData();
  }, []);
  return (
    <Fragment>
      <Helmet>
        <title>Ot Sales Return Reports</title>
      </Helmet>
      <Typography variant="h6">Ot Sales Return Reports</Typography>
      <Grid container spacing={2} className="p-2 pt-2">
        <Grid item md={3}>
          <Autocomplete
            size="small"
            value={cust}
            options={supplier}
            onChange={(e, value) => setCust(value)}
            // onChange={(e, value) => {
            //   setCust(value);
            //   // Trigger data fetch when outlet changes
            //   handlePaymentReport();
            // }}
            getOptionLabel={(option) => option.fullname}
            disabled={roleId != 1 && roleId != 2}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select Outlet"
                InputProps={{
                  ...params.InputProps,
                  readOnly: true,
                }}
              />
            )}
          />
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "fromDate")}
              value={dayjs(dateLimit.fromDate)}
              format="DD-MM-YYYY"
              slotProps={{
                textField: {
                  size: "small",
                  label: "From",
                  style: { width: "100%" },
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "toDate")}
              value={dayjs(dateLimit.toDate)}
              format="DD-MM-YYYY"
              slotProps={{
                textField: {
                  size: "small",
                  label: "To",
                  style: { width: "100%" },
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
      </Grid>
      <CustomTable props={props} />
      <Backdrop open={open} sx={{ zIndex: 9999 }}>
        <ModalTable
          tableHeadData={tableHeadData}
          tableBodyData={tableBodyData}
          setOpen={setOpen}
          data={rowData}
        />
      </Backdrop>
    </Fragment>
  );
};

export default memo(OtSalesReturn);
